import { Stack, Typography } from '@mui/material';
import { z } from 'zod';

const stringSchema = z.string();

export type Props = {
  /**
   * The decoration of the dialog (avatar, icon, etc)
   */
  decoration?: JSX.Element;

  /**
   * The title of the dialog. If it's a React Node, it will still be rendered as a Typography
   */
  title?: React.ReactNode | string;

  /**
   * The subtitle of the dialog
   */
  subTitle?: React.ReactNode;
};

const DialogTitle = ({ title, subTitle, decoration }: Props) => {
  const parsedSubTitle = stringSchema.safeParse(subTitle);

  return (
    <Stack spacing={0} pb={2.5} pr={3}>
      {Boolean(decoration) && decoration}

      {title && (
        <Typography mt={1.5} variant="h4">
          {title}
        </Typography>
      )}
      {parsedSubTitle.success && (
        <Typography variant="body1" color="text.secondary">
          {parsedSubTitle.data}
        </Typography>
      )}

      {subTitle && !parsedSubTitle.success && subTitle}
    </Stack>
  );
};

export default DialogTitle;
